import axios from 'axios';

class Api {
  baseUrl = '/api/';
  csrf = '';

  setCsrf(csrf) {
    this.csrf = csrf ?? '';
  }

  get(url) {
    return axios
      .get(`${this.baseUrl}${url}`, {headers: this.getHeaders()})
      .then(response => {
        return response.data;
      });
  }

  post(url, data) {
    const payload = {
      csrf_token: this.csrf,
      ...data
    };

    return axios
      .post(`${this.baseUrl}${url}`, new URLSearchParams(payload), {
        headers: this.getHeaders('application/x-www-form-urlencoded')
      })
      .then(response => {
        return response.data;
      });
  }

  getHeaders(contentType = 'application/json') {
    return { 'Content-Type': contentType };
  }
}

export const api = new Api();
